import { render, staticRenderFns } from "./InsightsCard.vue?vue&type=template&id=60b1ad35"
import script from "./InsightsCard.vue?vue&type=script&lang=js"
export * from "./InsightsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports